<template>
    <a-layout-header id="header">
        <a-row type="flex" justify="space-between" align="middle" style="height:64px;">
            <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toCollapsed" />
            <a-space>
                <a-popover placement="bottomRight" overlayClassName="user_guide" trigger="hover">
                    <a-button type="link" icon="question-circle" style="height:64px;">
                        如何开始
                    </a-button>
                    <template slot="content">
                        <a-list :data-source="guideList">
                            <a-list-item slot="renderItem" slot-scope="item, index">
                                <a-row
                                    type="flex"
                                    justify="space-between"
                                    align="middle"
                                    class="user_guide_item"
                                >
                                    <span style="margin-right:8px;">{{ item.name }}</span>
                                    <router-link :to="{ path: item.path }">
                                        前往设置
                                    </router-link>
                                </a-row>
                            </a-list-item>
                        </a-list>
                    </template>
                </a-popover>
                <a-popover
                    placement="bottomRight"
                    arrow-point-at-center
                    overlayClassName="user_info"
                    trigger="hover"
                    v-model="visible"
                >
                    <template slot="content">
                        <div class="user_info_item user_info_title">
                            <a-space align="center" size="middle">
                                <openData type="userName" :openid="userName"></openData>
                                <a-avatar :src="avatar" />
                            </a-space>
                        </div>
                        <div class="user_info_item user_info_cont">
                            <a-space direction="vertical">
                                <a-space align="center">
                                    <a-icon type="clock-circle" /><span
                                        >到期时间：{{ expTime }}</span
                                    >
                                </a-space>
                            </a-space>
                        </div>
                        <div class="user_info_item user_info_footer">
                            <span @click="toLogout" style="cursor: pointer;">退出登录</span>
                        </div>
                    </template>
                    <a-space align="center" style="cursor: pointer;">
                        <a-avatar :src="avatar" />
                        <a-icon
                            type="down"
                            :rotate="visible ? 180 : 0"
                            :style="{ fontSize: '12px' }"
                        />
                    </a-space>
                </a-popover>
            </a-space>
        </a-row>
    </a-layout-header>
</template>

<script>
import openData from '@/components/group/openData';
export default {
    components: {
        openData
    },
    data() {
        return {
            collapsed: false,
            visible: false,
            avatar: '',
            userName: '',
            expTime: '',
            guideList: [
                { name: '设置客户标签', path: 'tag' },
                { name: '设置企业素材', path: 'materials' },
                { name: '设置欢迎语', path: 'welcome' },
                { name: '设置聊天话术', path: 'word' },
                { name: '设置渠道码', path: 'code' }
            ]
        };
    },
    mounted() {
        this.avatar = window.sessionStorage.getItem('avatar');
        this.userName = window.sessionStorage.getItem('userName');
        this.expTime = window.sessionStorage.getItem('expTime');
    },
    methods: {
        toCollapsed() {
            this.collapsed = !this.collapsed;
            this.$store.commit('setCollapsed', this.collapsed);
        },
        toLogout() {
            window.sessionStorage.removeItem('token');
            window.sessionStorage.removeItem('avatar');
            window.sessionStorage.removeItem('expTime');
            window.sessionStorage.removeItem('userName');
            this.$router.push({ path: '/login' });
        },
        handleMenuClick(e) {
            if (e.key === '1') this.toLogout();
        }
    }
};
</script>

<style>
#header {
    background: #fff;
    padding: 0 30px;
}
#header .anticon-down svg {
    transition: all 0.3s;
}
.user_info .ant-popover-inner-content {
    padding: 20px 25px;
    padding-bottom: 0;
}
.user_info .user_info_title {
    padding-bottom: 20px;
    text-align: right;
}
.user_info .user_info_cont {
    text-align: left;
    padding: 20px 0;
    border-top: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
}
.user_info .user_info_footer {
    padding: 20px 0;
    text-align: right;
}
.user_guide .user_guide_item {
    width: 100%;
}
</style>
